import React, { useState } from 'react';
import {
  Button,
  Typography,
  Stack,
  IconButton,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { DOOR_TYPES, DOOR_DIRECTIONS } from '../../dataModels/decorators';
import { updateDoor } from '../../dataModels/room';

export function DoorEditing({ room, door, onClose, onSave, onChange }) {

  const updateDoorWithChange = (change) => {
    const updatedDoor = { ...door, ...change };
    const updatedRoom = updateDoor(room, updatedDoor);
    onChange(updatedRoom, 'door', updatedDoor);
  };

  const handleSave = () => {
    const updatedRoom = updateDoor(room, door);
    onSave(updatedRoom);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        עריכת דלת
      </Typography>

      <Stack spacing={3} sx={{ mt: 1 }}>
        <FormControl>
          <FormLabel>סוג דלת</FormLabel>
          <RadioGroup value={door.type} onChange={(e) => updateDoorWithChange( {type: e.target.value})} row>
            <FormControlLabel value={DOOR_TYPES.SLIDING} control={<Radio />} label="הזזה" />
            <FormControlLabel value={DOOR_TYPES.SWING} control={<Radio />} label="נדנדה" />
          </RadioGroup>
        </FormControl>

        <FormControl>
          <FormLabel>כיוון</FormLabel>
          <RadioGroup value={door.direction} onChange={(e) => updateDoorWithChange( {direction: e.target.value})} row>
            <FormControlLabel value={DOOR_DIRECTIONS.LEFT} control={<Radio />} label="שמאל" />
            <FormControlLabel value={DOOR_DIRECTIONS.RIGHT} control={<Radio />} label="ימין" />
            <FormControlLabel value={DOOR_DIRECTIONS.BOTH} control={<Radio />} label="שני הכיוונים" />
          </RadioGroup>
        </FormControl>

        <Stack direction="row" spacing={2}>
          <Button onClick={onClose}>ביטול</Button>
          <Button variant="contained" onClick={handleSave}>
            שמור
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

